/**
 * "Did the technician send anything back?" — one answer for the three shapes that carry field
 * feedback: `Appointment` and `Task` (comment + `technicianAttachments[]`) and `TaskListItem`
 * (comment + `technicianAttachmentCount`, because the board must not load every file).
 *
 * Structural on purpose so `shared` stays free of the contract's entity types.
 */
export interface TechnicianFeedbackSource {
  technicianComment?: string | null;
  technicianAttachments?: readonly unknown[] | null;
  technicianAttachmentCount?: number | null;
}

export interface TechnicianFeedbackSummary {
  hasComment: boolean;
  attachmentCount: number;
}

export const technicianAttachmentCount = (source: TechnicianFeedbackSource): number =>
  source.technicianAttachmentCount ?? source.technicianAttachments?.length ?? 0;

export const hasTechnicianComment = (source: TechnicianFeedbackSource): boolean =>
  Boolean(source.technicianComment?.trim());

export const summarizeTechnicianFeedback = (
  source: TechnicianFeedbackSource,
): TechnicianFeedbackSummary => ({
  hasComment: hasTechnicianComment(source),
  attachmentCount: technicianAttachmentCount(source),
});

export const hasTechnicianFeedback = (source: TechnicianFeedbackSource): boolean =>
  hasTechnicianComment(source) || technicianAttachmentCount(source) > 0;
